import React from "react";

import LearningPathCard from "components/Cards/LearningPathCard";
import { FormSpacer, Load, LoadCenter } from "ui/styled";
import useController from "./controller";
import {
  EmptyState,
  Grid,
  Header,
  HeaderContent,
  HeaderEyebrow,
  HeaderMeta,
  PageRoot,
  StatItem,
  StatLabel,
  StatValue,
  Subtitle,
  Title,
} from "./styled";

export default function LearningPathsList({ portal }) {
  const { loading, trails, handleAction } = useController(portal);
  const trailCount = trails.length;
  const courseCount = trails.reduce((total, trail) => total + Number(trail?.courseCount || 0), 0);
  const inProgressCount = trails.filter((trail) => Number(trail?.completionPercent || 0) > 0).length;

  return (
    <>
      <FormSpacer extraLarge />
      <PageRoot>
        <Header>
          <HeaderContent>
            <HeaderEyebrow>Learning paths</HeaderEyebrow>
            <Title>Learning Paths</Title>
            <Subtitle>Follow ordered course paths and track progress across each step.</Subtitle>
          </HeaderContent>

          <HeaderMeta>
            <StatItem>
              <StatValue>{trailCount}</StatValue>
              <StatLabel>Paths</StatLabel>
            </StatItem>
            <StatItem>
              <StatValue>{courseCount}</StatValue>
              <StatLabel>Courses</StatLabel>
            </StatItem>
            <StatItem>
              <StatValue>{inProgressCount}</StatValue>
              <StatLabel>In progress</StatLabel>
            </StatItem>
          </HeaderMeta>
        </Header>

        {loading ? (
          <LoadCenter><Load /></LoadCenter>
        ) : !trails.length ? (
          <EmptyState>No learning paths available.</EmptyState>
        ) : (
          <Grid>
            {trails.map((item) => (
              <LearningPathCard key={item.id} item={item} onAction={handleAction} />
            ))}
          </Grid>
        )}
      </PageRoot>
    </>
  );
}
